import { z } from 'zod'
import { isoDay, note300, uuid } from './primitives.ts'

/** M16-E: what was done on an infrastructure feature (32, GK-023; docs/M16.md E). A valve repaired, a head replaced, a drain flushed, a manhole inspected:
 *  the club's day, the kind, a note, the job or the workshop order it was done under. The schema mirrors `core.command_type.payload_schema` in
 *  `20261210100300_infra_maintenance.sql`; the contract check (ops/contracts/check.mjs) runs the same fixtures and random payloads through both.
 *  - `infra.record_maintenance@1` is a FACT of the field (a new permission `infra.maintain`: the crew and the mechanic by name, the direction by the generic
 *    rule; offline-first, projected in `sync/projectors.infra.ts`; kiosk-allowed by rule 9). `done_on` is the club's day (absent: the day of the command's
 *    moment, which the device derives the same way). A feature retired on a day takes the work dated up to that day and refuses work dated after it
 *    (`INFRA_RETIRED`): a fact of the field is never lost for what the office did while the phone was away. Nothing here schedules or decides anything. */
export const INFRA_MAINTENANCE_KINDS = ['repair', 'replace', 'flush', 'inspect', 'other'] as const
export type InfraMaintenanceKind = (typeof INFRA_MAINTENANCE_KINDS)[number]
/** The longest note (code points), the column's and the schema's bound. */
export const INFRA_MAINTENANCE_NOTE_MAX = 300

export const infraRecordMaintenanceV1 = z.strictObject({
  maintenance_id: uuid, feature_id: uuid, kind: z.enum(INFRA_MAINTENANCE_KINDS), done_on: isoDay.optional(), note: note300.optional(),
  job_id: uuid.optional(), work_order_id: uuid.optional(),
})

export type InfraRecordMaintenanceV1 = z.infer<typeof infraRecordMaintenanceV1>
